import { gql } from "@apollo/client";

export const ACCEPT_OR_REJECT_INITIATIVE_REFERRAL = gql`
  mutation Mutation($data: ReferralStatusInput) {
    acceptOrRejectInitiativeReferral(data: $data)
  }
`;
